<nav class="app-footer-theme" mat-content>
    <div class="footer-row-legal">
        <a mat-button color="primary" class="footerLinkItem" routerLink="ansprechpartner">
            Ansprechpartner
        </a>
        <a mat-button color="primary" class="footerLinkItem" routerLink="impressum">
            Impressum
        </a>
        <a mat-button color="primary" class="footerLinkItem" routerLink="datenschutz">
            Datenschutzerklärung
        </a>
    </div>
    <div class="footer-row-cpr">
        <span>&copy; {{currentYear}} YSTM - Yachtclub Steinhuder Meer e. V.</span>
    </div>
    <div class="app-version">v{{appVersion}}</div>
</nav>